<svg
  [attr.width]="size()"
  [attr.height]="size()"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  [attr.stroke-width]="stroke()"
  stroke-linecap="round"
  stroke-linejoin="round"
  aria-hidden="true"
>
  @switch (name()) {
    @case ('search') { <circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /> }
    @case ('plus') { <path d="M12 5v14M5 12h14" /> }
    @case ('filter') { <path d="M3 5h18M6 12h12M10 19h4" /> }
    @case ('more') {
      <circle cx="5" cy="12" r="1.2" fill="currentColor" stroke="none" />
      <circle cx="12" cy="12" r="1.2" fill="currentColor" stroke="none" />
      <circle cx="19" cy="12" r="1.2" fill="currentColor" stroke="none" />
    }
    @case ('chevron-down') { <path d="m6 9 6 6 6-6" /> }
    @case ('chevron-right') { <path d="m9 6 6 6-6 6" /> }
    @case ('chevron-left') { <path d="m15 6-6 6 6 6" /> }
    @case ('x') { <path d="M6 6l12 12M18 6 6 18" /> }
    @case ('check') { <path d="m5 13 4 4L19 7" /> }
    @case ('arrow-right') { <path d="M5 12h14M13 5l7 7-7 7" /> }
    @case ('edit') { <path d="M4 20h4l10.5-10.5a2.121 2.121 0 0 0-3-3L5 17v3ZM13.5 6.5l3 3" /> }
    @case ('trash') { <path d="M4 7h16M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2M6 7l1 13a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-13M10 11v7M14 11v7" /> }
    @case ('restore') { <path d="M3 12a9 9 0 1 0 3-6.7M3 4v5h5" /> }
    @case ('users') {
      <circle cx="9" cy="8" r="3.5" /><path d="M2.5 19a6.5 6.5 0 0 1 13 0" />
      <circle cx="17" cy="9" r="2.5" /><path d="M21.5 18.5A4.5 4.5 0 0 0 17 14" />
    }
    @case ('user') { <circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0" /> }
    @case ('building') {
      <path d="M4 21V5a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v16" />
      <path d="M17 9h2a2 2 0 0 1 2 2v10" />
      <path d="M8 7h2M8 11h2M8 15h2M13 7h2M13 11h2M13 15h2" />
      <path d="M2 21h20" />
    }
    @case ('home') { <path d="M3 10.5 12 3l9 7.5V21a1 1 0 0 1-1 1h-5v-7h-6v7H4a1 1 0 0 1-1-1V10.5Z" /> }
    @case ('workflow') {
      <rect x="3" y="3" width="6" height="6" rx="1" /><rect x="15" y="3" width="6" height="6" rx="1" />
      <rect x="9" y="15" width="6" height="6" rx="1" /><path d="M6 9v3h12V9M12 12v3" />
    }
    @case ('clock') { <circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /> }
    @case ('bell') { <path d="M6 8a6 6 0 0 1 12 0c0 5 2 6 2 6H4s2-1 2-6ZM10 20a2 2 0 0 0 4 0" /> }
    @case ('settings') {
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 0 1-4 0v-.1a1.7 1.7 0 0 0-1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 0 1 0-4h.1a1.7 1.7 0 0 0 1.5-1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3h0a1.7 1.7 0 0 0 1-1.5V3a2 2 0 0 1 4 0v.1a1.7 1.7 0 0 0 1 1.5h0a1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8v0a1.7 1.7 0 0 0 1.5 1H21a2 2 0 0 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1Z" />
    }
    @case ('shield') { <path d="M12 3 4 6v6c0 5 3.5 8.5 8 9 4.5-.5 8-4 8-9V6l-8-3Z" /> }
    @case ('key') { <circle cx="7.5" cy="15.5" r="4.5" /><path d="m10.7 12.3 8.3-8.3M16 7l2.5 2.5M13.5 9.5 16 12" /> }
    @case ('eye') { <path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7-10-7-10-7Z" /><circle cx="12" cy="12" r="3" /> }
    @case ('eye-off') { <path d="M9.9 5.2A9.5 9.5 0 0 1 12 5c6.4 0 10 7 10 7a18 18 0 0 1-3.2 4.2M6.2 6.2A18 18 0 0 0 2 12s3.6 7 10 7a9.5 9.5 0 0 0 3.9-.8" /><path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" /><path d="m3 3 18 18" /> }
    @case ('copy') { <rect x="9" y="9" width="11" height="11" rx="2" /><path d="M5 15V5a2 2 0 0 1 2-2h10" /> }
    @case ('download') { <path d="M12 3v12M7 10l5 5 5-5M4 21h16" /> }
    @case ('upload') { <path d="M12 21V9M7 14l5-5 5 5M4 3h16" /> }
    @case ('grid') {
      <rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" />
      <rect x="3" y="14" width="7" height="7" /><rect x="14" y="14" width="7" height="7" />
    }
    @case ('mail') { <rect x="3" y="5" width="18" height="14" rx="1.5" /><path d="m3 7 9 6 9-6" /> }
    @case ('phone') { <path d="M5 4h3l2 5-2.5 1.5a11 11 0 0 0 6 6L15 14l5 2v3a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2Z" /> }
    @case ('sort') { <path d="M7 4v16M3 8l4-4 4 4M17 20V4M13 16l4 4 4-4" /> }
    @case ('star') { <path d="m12 3 2.9 5.9 6.6 1-4.8 4.6 1.1 6.5L12 17.8 6.2 21l1.1-6.5L2.5 9.9l6.6-1L12 3Z" /> }
    @case ('link') { <path d="M10 14a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1M14 10a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1" /> }
    @case ('calendar') { <rect x="3" y="5" width="18" height="16" rx="1.5" /><path d="M3 9h18M8 3v4M16 3v4" /> }
    @case ('logout') { <path d="M15 4h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3M10 17l-5-5 5-5M5 12h12" /> }
    @case ('clipboard') {
      <rect x="6" y="4" width="12" height="17" rx="1.5" />
      <path d="M9 4V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1M9 11h6M9 15h6M9 8h6" />
    }
    @case ('briefcase') {
      <rect x="3" y="7" width="18" height="13" rx="1.5" />
      <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M3 13h18" />
    }
    @case ('activity') { <path d="M3 12h4l3-8 4 16 3-8h4" /> }
    @case ('file-text') {
      <path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9l-6-6Z" />
      <path d="M14 3v6h6M8 13h8M8 17h8M8 9h3" />
    }
  }
</svg>
